import { FiBell } from "react-icons/fi";

const NotificationIcon = ({ count }) => {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <FiBell size={24} />
      {count > 0 && (
        <span
          style={{
            position: "absolute",
            top: -8,
            right: -9,
            background: "red",
            color: "white",
            borderRadius: "50%",
            padding: "2px 5px 1px 3px",
            fontSize: "10px",
            fontWeight: "bolder",
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
};

export default NotificationIcon;
